import React from 'react';

/*
 * FormContext
 *
 * A react context to pass apis
 */

const FormContext = React.createContext(undefined);
export default FormContext;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/vendor/react-store/components/General/Form/FormContext.js